import React, { type ReactNode } from 'react';

import { IntlProvider } from 'react-intl-next';

import { type LazyMessages } from './types';
import { DEFAULT_LOCALE, getCodesFromLocale, useLazyMessages } from './utils';

interface Props {
	children: ReactNode;
	locale: string;
	messages: LazyMessages;
}

export const ProformaIntlProvider: React.FC<Props> = ({ children, locale, messages }) => {
	const { language, country } = getCodesFromLocale(locale) ?? {};

	const lazyMessages = useLazyMessages(messages, language ?? DEFAULT_LOCALE, country);
	if (lazyMessages === undefined) {
		return null;
	}

	return (
		<IntlProvider
			messages={lazyMessages}
			locale={(country && `${language}-${country}`) || language || locale.replace('_', '-')}
			defaultLocale={DEFAULT_LOCALE}
			defaultRichTextElements={{
				b: (chunks) => <b>{chunks}</b>,
				strong: (chunks) => <strong>{chunks}</strong>,
			}}
		>
			{children}
		</IntlProvider>
	);
};
